<template>
  <v-container fluid>
    <Breadcrumbs />
    <router-view name="action" />
    <router-view name="view" />
  </v-container>
</template>
<script>
import Breadcrumbs from "../components/Breadcrumbs.vue";
export default {
  name: "Disciplinary",
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      //
    };
  },
};
</script>
